import React, { useState, useEffect } from 'react'
import { AXIOS } from '../api'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { useDropzone } from 'react-dropzone'
import { ChromePicker } from 'react-color'
import { v4 as uuidv4 } from 'uuid'
import { useForm } from 'react-hook-form'
import { Title, Picture } from './common/Themes'

import { setFetch, setLoading } from '../redux/actions'
import ItemsList from './common/ItemsList'


const NewAccessoire = () => {

    const dispatch = useDispatch()
    const { activites, articles } = useSelector(state => state.fetch)
    const { fetch } = useSelector(state => state.config)

    const [file, setFile] = useState({})
    const [color, setColor] = useState({ hex: '#FF5C00', rgb: { r: 245, g: 68, b: 46, a: .8 } })
    const history = useHistory()

    const [articlesFill, setArticlesFill] = useState([])
    const [selectedArticle, setSelectedArticle] = useState(null)

    useEffect(() => {
        setArticlesFill(articles)
    }, [articles])

    const { handleSubmit, register, errors } = useForm()

    const onSubmit = async values => {
        try {
            dispatch(setLoading(true))
            const aid = values.aid === "null" ? null : values.aid
            delete values.aid

            const uuid = uuidv4()
            const body = {
                ...values,
                aid,
                cid: uuid,
                article: selectedArticle,
                color: color.hex,
                image: `/uploads/accessoires/${uuid}.png`
            }

            const formData = new FormData()
            formData.append('file', file)

            if (Object.keys(file).length !== 0)
                await AXIOS.post(`/api/v1/uploads/accessoires/${uuid}`, formData)

            await AXIOS.post('/api/v1/accessoires', body)
            history.push('/accessoires')
            dispatch(setFetch(!fetch))
            dispatch(setLoading(false))
        } catch (error) {
            console.log(error)
        }
    }

    // DROPZONE IMAGE --------------------------------------------------------------------------------------------------------
    const [imageURL, setImageURL] = useState('')

    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: acceptedFiles => {
            acceptedFiles.map(file => {
                Object.assign(file, {
                    preview: URL.createObjectURL(file)
                })
                setFile(acceptedFiles[0])
                console.log('file : ', file)
                const reader = new FileReader();
                reader.onload = (event) => {
                    setImageURL(event.target.result);
                };
                reader.readAsDataURL(file);
            });
        }
    });

    const handleChange = e => setArticlesFill(articles.filter(({ name }) => name.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase())))

    return (
        <div className="gestion">
            <div className="gestion__header">
                <h4 className="gestion__title">Nouveau accessoire</h4>
            </div>
            <div className="gestion__wrapper">
                <form onSubmit={handleSubmit(onSubmit)} className="form">
                    <div className="form__container" >
                        <div className="form__inputboxWrapper">
                            <Title color={'#183a68'}>Fiche accessoire :</Title>
                            <div className="form__inputboxWrapper" style={{ width: '100%' }}>
                                <div className="form__inputbox">
                                    <label htmlFor="name" className="form__label">Nom</label>
                                    <input name="name" ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.name && errors.name.message}
                                </div>
                                <div className="form__inputbox">
                                    <label htmlFor="birthday" className="form__label">Activité</label>
                                    <select name="aid" ref={register({ required: 'Required' })} className="form__input" style={{ padding: '0 1rem' }}>
                                        {activites.map(({ aid, name }) => <option className="form__dropdown" key={aid} value={aid}>{name}</option>)}
                                    </select>
                                    {errors.aid && errors.aid.message}
                                </div>
                                <div className="form__inputbox">
                                    <label htmlFor="birthday" className="form__label">Classement</label>
                                    <input name="classement" type="number" min="1" defaultValue="1" ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.aid && errors.classement.message}
                                </div>
                            </div>
                        </div>
                        <div style={{ width: '25%', height: '100%' }}>
                            <Title color={'#183a68'}>Accessoire démo :</Title>
                            <div className="card card__accessoire">
                                <Picture image={imageURL ? imageURL : '/img/default_image.png'} style={{ borderRadius: '2rem' }}>&nbsp;</Picture>
                            </div>
                        </div>
                    </div>

                    <div className="form__container">

                        {/*🐫👽👼 */}
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="birthday" className="form__label">Article V12</label>
                            <input name="search" onChange={handleChange} placeholder="Rechercher" className="form__input  list__input" />
                            <div className="list__wrapper">
                                <ItemsList
                                    articles={articlesFill}
                                    selectedArticle={selectedArticle}
                                    setSelectedArticle={setSelectedArticle}
                                />
                            </div>
                        </div>

                        <div className="gestion__imageWrapper">
                            <label htmlFor="image" className="form__label">Importer une image</label>
                            <div {...getRootProps()} className="dropzone">
                                <input {...getInputProps()} />
                                <img src="/img/icon/upload.svg" alt="upload" style={{ width: '120px' }} />
                            </div>
                        </div>

                        <div className="gestion__colorWrapper">
                            <label htmlFor="color" className="form__label">Choisir un color</label>
                            <div style={{ marginTop: '1rem' }}>
                                <ChromePicker color={color} onChange={color => setColor(color)} />
                            </div>
                        </div>

                    </div>

                    <div className="gestion__buttonWrapper">
                        <button className="facture__button" style={{ fontSize: '1.5rem', width: '15rem', backgroundColor: '#0D53FC' }}>Ajouter</button>
                        <Link to='/accessoires'>
                            <button className="facture__button" style={{ fontSize: '1.5rem', width: '15rem', backgroundColor: '#fc114c' }}>Fermer</button>
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default NewAccessoire